import { createApiClient } from 'Network/ApiClient';

export const DrugNotAllowedIncludeDrugAxiosInstance = createApiClient('Drugs/');


